import React, { useEffect, useState } from "react";
//import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import MoveTopButton from "../MoveTopButton";
import { BarChart,XAxis, YAxis,Bar,Tooltip,ResponsiveContainer,Cell,LabelList,CartesianGrid } from 'recharts';
import { productServices } from "../../../api/services/products";
import { ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { formatCurrencyEuro, formatDate, formatDecimal, formatPatrimonio } from "../../../helpers/format";
import { DatePicker, Modal } from "antd";
import { useFundDetailsContext } from "../../../context/FundDetailsContext";
import arrowTop from '../../../imgs/ico-arrow-top.png';
import arrowDown from '../../../imgs/ico-arrow-down.png';

import chartIcon from '../../../imgs/barchart.png';
import inlineIcon from '../../../imgs/inline-text.png';

import locale from 'antd/lib/date-picker/locale/es_ES';
import RiskIndicator from '../../Common/RiskIndicator/RiskIndicator';

import moment from 'moment';
import 'moment/locale/es'; 

const { RangePicker } = DatePicker;


const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

const plazoToText = {
    // Mapeo para cortoplazo
    diaria: "Día",
    semana: "Semana",
    mes: "Mes",
    tresmeses: "3 meses",
    seismeses: "6 meses",
    YTD: "YTD",
    "365 dias": "365 días",

    // Mapeo para largoplazo
    "1anio": "1 año",
    "3años": "3 años",
    "5años": "5 años",
    "10años": "10 años",
    "15años": "15 años",
    "20años": "20 años",
    // Otros valores de largoplazo
    desdeIncio: "Desde inicio",
};

const RentabilidadesTab = ({showCalendarInfo, setShowCalendarInfo, selectedProduct}) => {
    const [calendarValue, setCalendarValue] = useState(null);
    const [modalVisible, setModalVisible] = useState(false)
    const [showDetailModal, setShowDetailModal] = useState({
        title: '',
        content: '',
    });

    const [detalleproducto, setDetalleproducto] = useState(null);
    const [datospatrimonio, setDatospatrimonio] = useState(null);
    const [datosgestores, setDatosgestores] = useState(null);
    const [comisiones, setComisiones] = useState(null);
    const [rentabilidad, setRentabilidad] = useState(null);
    const [antiguaDenominacion, setAntiguaDenominacion] = useState(null);

    const [cortoPlazoData, setCortoPlazoData] = useState(null);
    const [largoPlazoData, setLargoPlazoData] = useState(null);
    const [aniosNaturalesData, setAniosNaturalesData] = useState(null);

    const { setProductDetail } = useFundDetailsContext();
    const { productDetail } = useFundDetailsContext();
    const dateFormat = "DD/MM/YYYY";
    const dateFormatRent = "YYYY-MM-DD";

    const [cortoPlazoToggleDisplay, setCortoPlazoToggleDisplay] = useState(false);
    const [largoPlazoToggleDisplay, setLargoPlazoToggleDisplay] = useState(false);
    const [aniosNatToggleDisplay, setAniosNatToggleDisplay] = useState(false);

    const barColors = [
        '#e59d27', '#abc111', '#1bb3bc', '#9e3667', '#fecc09','#cc0000','#406DFE'
    ]

    let codProduct = "";
    let initialDate;
    let endDate;
    const [rentaInfo, setRentaInfo] = useState([]);
    const [showRentaInfo, setShowRentaInfo] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);

    const riesgoProducto = detalleproducto?.riesgo;

    const generalDataTable = [
        { text: detalleproducto?.tipo === 'epvs' ? 'Categoría del Gobierno Vasco' : detalleproducto?.tipo === 'planes' ? 'Categoría DGS' : detalleproducto?.tipo === 'fondos' ? 'Categoría de CNMV' : detalleproducto?.tipo === 'sicav' ? 'Categoría de la CSSF': 'Categoría', value: detalleproducto?.vocacion ? detalleproducto?.vocacion : '-' },
        { text: 'Riesgo', value: <RiskIndicator riskLevel={riesgoProducto ? riesgoProducto : '-'} productType={detalleproducto?.tipo} /> },
        { text: 'Patrimonio', value: datospatrimonio?.[0]?.patrimonio ? formatPatrimonio(datospatrimonio?.[0]?.patrimonio, detalleproducto?.divisa) : '-'},
        { text: 'Divisa', value: detalleproducto?.divisa ? detalleproducto?.divisa : '-'},
        { text: 'Inversión mínima', value: detalleproducto?.inversionMinima ? detalleproducto?.inversionMinima : '-'}
    ]

    //modificar el valor tener encuenta object del mock
    if(detalleproducto?.tipo !== `epvs`){
        generalDataTable.push(
            { 
                text: 'Comisión de gestión', 
                value: ((comisiones?.comisiongestion && (comisiones.comisiongestion.length > 5)) || (comisiones?.comisionperformancefee && comisiones.comisionperformancefee.length > 5) ) ? (
                <div className="statement" onClick={() => handleOpenModal('Comisión de gestión',
                (<>
                    <div className="mb-4">
                        <ul>
                            <li>Gestión:  {formatDecimal(comisiones?.comisiongestion).replaceAll("#"," ").replaceAll("@"," ")}</li>
                            <li>Beneficios: {formatDecimal(comisiones?.comisionperformancefee)}</li>
                        </ul>
                    </div>
                    <div style={{height: 40, display: 'flex', justifyContent: 'center'}}>
                        <button onClick={() => setModalVisible(false)} className="infoButton">OK</button>
                    </div>
                </>)
            )} style={{textTransform: "initial", color: 'red', cursor: "pointer"}}><span className="look-detail">Ver detalle</span></div>     
            ) : (formatDecimal(comisiones?.comisiongestion) ? formatDecimal(comisiones?.comisiongestion) + "%" : '-') }
        );
        generalDataTable.push(
            { 
                text: 'Comisión de depósito', 
                value: (formatDecimal(comisiones?.comisionDeposito) && (comisiones.comisionDeposito.length > 5)) ? (
                <div className="statement" onClick={() => handleOpenModal('Comisión de depósito',
                    (<>
                        <div className="mb-4">
                            <div>Depósito:  {(comisiones?.comisionDeposito).replaceAll("#"," ").replaceAll("@", ". ")}</div>
                        </div>
                        <div style={{height: 40, display: 'flex', justifyContent: 'center'}}>
                            <button onClick={() => setModalVisible(false)} className="infoButton">OK</button>
                        </div>
                    </>)
                    )} style={{textTransform: "initial", color: 'red', cursor: "pointer"}}><span className="look-detail">Ver detalle</span></div>     
                ) : (formatDecimal(comisiones?.comisionDeposito) ? formatDecimal(comisiones?.comisionDeposito) + "%" : '-') }
            );
        generalDataTable.push({ 
            text: 'Comisiones de Suscripción y Reembolso', 
            value: ((comisiones?.comisionreembolso && (comisiones.comisionreembolso.length > 5)))  || ((comisiones?.comisionsuscripcion && (comisiones.comisionsuscripcion.length > 5))) ?
            <div className="statement" onClick={() => handleOpenModal('Comisiones de Suscripción y Reembolso',
                (<>
                    <div className="mb-4">
                        <ul>
                            <li>Reembolso:  {(formatDecimal(comisiones?.comisionreembolso)).replaceAll("#"," ")}</li>
                            <li>Suscripción: {(formatDecimal(comisiones?.comisionsuscripcion)).replaceAll("#"," ")}</li>
                        </ul>
                    </div>
                    <div style={{height: 40, display: 'flex', justifyContent: 'center'}}>
                        <button onClick={() => setModalVisible(false)} className="infoButton">OK</button>
                    </div>
                </>
                )
                )} style={{textTransform: "initial", color: 'red', cursor: "pointer"}}><span className="look-detail">Ver detalle</span>
            </div>
            : 
            <span className="statement"> - </span>
        });
    } else {
        generalDataTable.push({ text: detalleproducto?.tipo === 'epvs' ? 'Gastos de administración' : 'Gastos administrativos', value: detalleproducto?.gastosAdministracion + `%` || '-' });
    };

    const onSelectedDate = (date) =>{
        setCalendarValue(date); 
        setShowCalendarInfo(false);
        initialDate = moment(date[0]).format(dateFormatRent);
        endDate = moment(date[1]).format(dateFormatRent);
        //productServices.getRentaResume(detalleproducto?.isin, initialDate, endDate);
        fetchRentaResume(detalleproducto?.isin, initialDate, endDate);
        handleSearchRenta();
    }

    const fetchRentaResume = async (isin, initialDate, endDate) => {
        try {
            codProduct = isin ? isin : detalleproducto?.codigoDgs;
          return await productServices.getRentaResume(
            codProduct,
            initialDate, 
            endDate,
            detalleproducto?.tipo
          );
        } catch {
          return null;
        }
      };

    const handleSearchRenta = () => {
        if (!initialDate) {
            setShowErrorMessage(true);
          return;
        }
        fetchRentaResume(codProduct, initialDate, endDate).then((response) => {
            if(response) {
                setRentaInfo([
                    {
                      title: "Valor inicial",
                      date: null,
                      value: response.rentabilidadfechas.valorinicial ? formatDecimal(response.rentabilidadfechas.valorinicial, 5) : '-',
                    },
                    {
                      title: "Valor final",
                      date: null,
                      value: response.rentabilidadfechas.valorfinal ? formatDecimal(response.rentabilidadfechas.valorfinal, 5) : '-',
                    },
                    {
                      title: response.rentabilidadfechas.diasCalc > 365 ? "TAE" : "Acumulado",
                      date: null,
                      value: response.rentabilidadfechas.diasCalc > 365
                      ? response.rentabilidadfechas.tae ? `${formatDecimal(response.rentabilidadfechas.tae, 2)}%` : '-'
                      : response.rentabilidadfechas.acumulado && response.rentabilidadfechas.acumulado !== '-' ? `${formatDecimal(response.rentabilidadfechas.acumulado, 2)}%` : '-'
                    }
                  ]);
                  setShowRentaInfo(true);
            }
        })
      }

    const addPercentLabel= (value) => {
        return value !== "-" ? value + '%' : value = "";
    };

    useEffect(() => {
        setProductDetail(selectedProduct);
        setDetalleproducto(selectedProduct?.detalleproducto);
        setDatospatrimonio(selectedProduct?.datospatrimonio);
        setDatosgestores(selectedProduct?.datosgestores);
        setComisiones(selectedProduct?.comisiones);
        setRentabilidad(selectedProduct?.rentabilidad);
        setAntiguaDenominacion(selectedProduct?.antiguaDenominacion);
        
        const translatePlazos = (key) => {
            return selectedProduct?.rentabilidad?.[key].map(item =>
                {
                    return{
                        ...item,plazo: key !== "aniosnaturales" ? plazoToText[item.plazo] : item.plazo,
                        acumulado: item.acumulado !== '-' ?  parseFloat(item.acumulado).toFixed(2) : '-',
                        tae: item.tae !== '-' ?  parseFloat(item.tae).toFixed(2) : '-'
                    }
                }
            )
        }

        setCortoPlazoData(translatePlazos("cortoplazo"));
        setLargoPlazoData(translatePlazos("largoplazo"));
        setAniosNaturalesData(translatePlazos("aniosnaturales"));
    }, [selectedProduct, setProductDetail]);

    const handleOpenModal = (title, content) => {
        setShowDetailModal({
            title: title,
            content: content
        })
        setModalVisible(true);
    };

    let informeProductoURL;
    let datosFundamentalesURL;
    let datosFundamentalesURLDIP;
    let datosFundamentalesURLKIID;

    if (productDetail && productDetail.documentacion) {
            const { documentacion } = productDetail;
            let https = 'https';
            const baseURLBackend = process.env.BACKEND_ENDPOINT;
            const informeProducto = documentacion.filter(
                (doc) => doc.txdesdoc === "pdfInformeDeProducto"
            );
            informeProductoURL = informeProducto[0]?.urlcompleta || '-';

            const datosFundamentales = documentacion.filter(
                (doc) => doc.txdesdoc === "pdfFolletoExplicativo"
            );
            datosFundamentalesURL = datosFundamentales[0]?.urlcompleta || '-';
            
            if(datosFundamentales){
                datosFundamentalesURL = datosFundamentales[0]?.urlcompleta || '-' ;
                datosFundamentalesURL = datosFundamentalesURL.includes(https) === true ?
                datosFundamentalesURL
                : baseURLBackend + datosFundamentalesURL;
            }

            const datosFundamentalesKIID = documentacion.filter(
                (doc) => doc.txdesdoc === "pdfFolleto"
            );

            if(datosFundamentalesKIID){
                datosFundamentalesURLKIID = datosFundamentalesKIID[0]?.urlcompleta || '-' ;
                datosFundamentalesURLKIID = datosFundamentalesURLKIID.includes(https) === true ?
                datosFundamentalesURLKIID
                : baseURLBackend + datosFundamentalesURLKIID;
            }

            const datosFundamentalesDIP = documentacion.filter(
                (doc) => doc.txdesdoc === "pdfDocumentodeInformacionPrevia"
            );
            
            if(datosFundamentalesDIP){
                datosFundamentalesURLDIP = datosFundamentalesDIP[0]?.urlcompleta || '-' ;
                datosFundamentalesURLDIP = datosFundamentalesURLDIP.includes(https) === true ?
                datosFundamentalesURLDIP
                : baseURLBackend + datosFundamentalesURLDIP;
            }
    };

    return (
        <>
            {!selectedProduct ? (
                <div className="alert alert-danger mt-3" role="alert">Se ha producido un error, vuelve a intentarlo</div>
            ) : (
                <div style={{marginTop: 10}}>
                    <h4 className="blueText" id="datos">Datos generales</h4>
                    <div style={{marginTop: 20, textTransform: 'uppercase', fontSize: 14}} className="row">
                        <div className="col-lg-4 col-md-6 col-sm-12" style={{marginTop: 10}}>
                            <span className="text-span">Fecha última valoración:</span> <span>{ formatDate(detalleproducto?.fechaUltimaValoracion) || '-' }</span>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12" style={{marginTop: 10}}>
                            <span className="text-span">Valor liquidativo:</span> <span>{ formatCurrencyEuro(detalleproducto?.valorParticipacion, 5) || '-' }</span>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12" style={{marginTop: 10}}>
                            <span className="text-span">Fecha constitución:</span> <span>{ formatDate(detalleproducto?.fechaConstitucion) || '-' }</span>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12" style={{marginTop: 10}}>
                            <span className="text-span">Fecha alta en la CNMV:</span> <span>{ formatDate(detalleproducto?.fechaAlta) || '-' }</span>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12" style={{marginTop: 10}}>
                            <span className="text-span">Antigua denominación:</span> { antiguaDenominacion?.length > 0 ? 
                            <span onClick={() => handleOpenModal('Antigua denominación',
                            (<>
                                <div className="mb-4">
                                    <ul>
                                        {
                                            antiguaDenominacion?.map((info) => (
                                                <li key={info.denominacion} >{info.denominacion} : {formatDate(info.fechadenominacion)}</li>
                                            ))
                                        }
                                    </ul>
                                </div>
                                <div style={{height: 40, display: 'flex', justifyContent: 'center'}}>
                                    <button onClick={() => setModalVisible(false)} className="infoButton">OK</button>
                                </div>
                            </>)
                            )} style={{textTransform: "initial", color: 'red', cursor: "pointer"}}>Ver detalle</span>
                            : <span> - </span>
                            }
                        </div>
                    </div>
                    <div className="box-detail">
                        <div className="row">
                            {
                                generalDataTable?.map((e, idx) =>
                                    <div key={idx} className="col-lg-3 col-md-6 col-sm-12" style={{marginTop: idx < 4 ? 10 : 30}}>
                                        <span className="statement">
                                            {e.value}
                                        </span>
                                        <span className="statementDetail">
                                            {e.text}
                                        </span>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    {(detalleproducto?.tipo === `planes`) && (
                        <div className="textLiquidez">
                            <h4 className="blueText" id="gestor">Alertas de liquidez</h4>
                                <ul>
                                    <li class="candadoLiquidez">El cobro de la prestación o el ejercicio del derecho de rescate sólo es posible en caso de acaecimiento de alguna de las contigencias o supuestos excepcionales de liquidez regulados en la normativa de planes y fondos de pensiones.</li>
                                    <li class="candadoLiquidez">El valor de los derechos de movilización, de las prestaciones y de los supuestos excepcionales de liquidez depende del valor de mercado de los activos del fondo de pensiones y puede provocar pérdidas relevantes.</li>
                                </ul>
                        </div>
                    )}
                    {(detalleproducto?.url != null || detalleproducto?.sostenibilidad != null) && (
                        <div>
                            <h4 className="blueText" id="producto">Información en Materia de Sostenibilidad</h4>
                            {detalleproducto?.sostenibilidad != null && <p className="text-parraf">{detalleproducto?.sostenibilidad}</p>}
                            {detalleproducto?.url != null &&
                                <p className="text-parraf">En este enlace de <a href={detalleproducto?.url} target="blank">información en materia de sostenibilidad</a> podrá consultar las secciones del sitio web dedicadas a la información relativa a los productos financieros que promueven características medioambientales o sociales</p>
                            }
                        </div>
                    )}
                    <div>
                        <h4 className="blueText" id="resumen">Resumen rentabilidades</h4>
                        <div style={{marginTop: 30}}>Fecha de última valoración: { formatDate(detalleproducto?.fechaUltimaValoracion) || '-' }</div>
                        <div className="d-flex">
                            {<div className="w-50">
                                <div className='search-center-dropdown main-search'
                                    style={{maxWidth: 350, marginBottom: 10}}
                                    onClick={() => {setShowCalendarInfo(true);}}
                                    >
                                    <RangePicker
                                        locale={locale}
                                        format={dateFormat}
                                        className="date-picker d-flex"
                                        onChange={onSelectedDate}
                                    />
                                </div>
                                {
                                    showCalendarInfo
                                }
                            </div>}
                            {
                                calendarValue &&
                                <span style={{marginLeft: 30, top: 10, position: 'relative'}}>{months[calendarValue[0].month()]+ ' ' + calendarValue[0].year()} - {months[calendarValue[1].month()] + ' ' + calendarValue[1].year()} </span>
                            }
                        </div>
                        { showRentaInfo &&
                            <div className="row">
                            { rentaInfo.length > 0 && rentaInfo.map((e, idx) =>
                                <div className="col-lg-3 col-md-3 col-sm-6" key={idx} style={{padding: 10}}>
                                    <div className style={{cursor: 'default', textAlign: 'left', maxWidth: 'inherit', margin: 0, height: 112}}>
                                        <div style={{fontSize: 20, fontWeight: 600, marginBottom: 5}}>{e.value}</div>
                                        <div>{e.title}</div>
                                    </div>
                                </div>
                            )}
                        </div>
                        }
                        {showErrorMessage && (
                            <div>
                                <div className="alert alert-warning mt-3" role="alert">La fecha desde debe estar informada y ser válida.</div>
                            </div>
                        )}
                        <div className="box-detail details-returns">
                            {
                            <div className="row">
                                <div className="cortoPlazo-display" style={{marginBottom: 20}}>
                                    <h4 className="details-returns-title">Corto Plazo</h4>
                                    <div className="switch-display-buttons" id="cortoPlazo-buttons">
                                        {<ToggleButtonGroup type="radio" name="optionsCortoPlazo" defaultValue={1} className="toggle-options" id="cortoPlazo-toggle">
                                            <ToggleButton id="cortoPlazo-radio-1" value={1} className="toggle-option-nums" onClick={ () => setCortoPlazoToggleDisplay(false)}>
                                                <img src={inlineIcon} className="num-icon" alt="icono numero"/>
                                            </ToggleButton>
                                            <ToggleButton id="cortoPlazo-radio-2" value={2} className="toggle-option-graphs" onClick={ () => setCortoPlazoToggleDisplay(true)}>
                                                <img src={chartIcon} className="chart-icon" alt="icono chart"/>
                                            </ToggleButton> 
                                        </ToggleButtonGroup>}
                                    </div>
                                    {cortoPlazoToggleDisplay ? 
                                        <div className="cortoPlazo-graphs-display d-flex flex-row justify-content-center">
                                            {    
                                                <ResponsiveContainer  width="100%" height={600}>
                                                    <BarChart width="100%" height="100%" data={cortoPlazoData} margin={{top: 20, right: 20, bottom: 20, left: 20}} >
                                                        <XAxis dataKey="plazo" padding={{ top: 20, bottom: 20 }} />
                                                        <YAxis type="number" dataKey="" />
                                                        <Tooltip />
                                                        <CartesianGrid strokeDasharray="1 3"/>
                                                        <Bar dataKey="acumulado" fill="#000000" >
                                                            {barColors.map((entry, index) => (
                                                                <Cell key={`cell-${index}`} fill={barColors[index]} />
                                                            ))}
                                                            <LabelList dataKey="acumulado" position="top" fill="#000" formatter={addPercentLabel}/>
                                                        </Bar>
                                                    </BarChart> 
                                                </ResponsiveContainer>
                                                
                                            } 
                                        </div> 
                                        : 
                                        <div className="cortoPlazo-numeric-display d-flex flex-row justify-content-center">
                                            {
                                                //Tras revisión de cumplimiento solicitan no mostrar el correspondiente a 365 días ya que se muestra en la rent. largo plazo con 1 año
                                                rentabilidad?.cortoplazo.slice(0, -1).map((item, idx) => 
                                                    <div key={`cortoplazo_${idx}`} className="flex-fill" style={{ marginTop: 10 }}>
                                                        <span className="statement">
                                                            {item.acumulado !== '-' ?  parseFloat(item.acumulado).toFixed(2) + '%' : '-'}
                                                            {(item.acumulado !== '-' && item.acumulado > 0) && (<img className="icon" src={arrowTop} alt="flecha arriba"/>)}
                                                            {(item.acumulado !== '-' && item.acumulado < 0) && (<img className="icon" src={arrowDown} alt="flecha abajo"/>)}
                                                        </span>
                                                        <span className="statementDetail">
                                                            {plazoToText[item.plazo]}
                                                        </span>
                                                    </div>)
                                            }
                                        </div>
                                    }       
                                </div>
                                <hr className="separator" />
                                <div className="largoPlazo-display" style={{marginBottom: 20}}>
                                    <h4 className="details-returns-title">Largo Plazo</h4>
                                    <div className="switch-display-buttons" id="largoPlazo-buttons">
                                        {<ToggleButtonGroup id="largoPlazo-toggle" type="radio" name="optionsLargoPlazo" defaultValue={"largoPlazo-1"} className="toggle-options">
                                            <ToggleButton id="largoPlazo-radio-1" value={"largoPlazo-1"} className="toggle-option-nums" onClick={ () => setLargoPlazoToggleDisplay(false)}>
                                                <img src={inlineIcon} className="num-icon" alt="icono numero"/>
                                            </ToggleButton>
                                            <ToggleButton id="largoPlazo-radio-2" value={"largoPlazo-2"} className="toggle-option-graphs" onClick={ () => setLargoPlazoToggleDisplay(true)}>
                                                <img src={chartIcon} className="chart-icon" alt="icono chart"/>
                                            </ToggleButton> 
                                        </ToggleButtonGroup>}
                                    </div>
                                    {largoPlazoToggleDisplay ? 
                                        <div className="d-flex flex-row justify-content-center">
                                        {    
                                            <ResponsiveContainer  width="100%" height={600}>
                                                <BarChart width="100%" height="100%" data={largoPlazoData} margin={{top: 20, right: 20, bottom: 20, left: 20}} >
                                                    <XAxis dataKey="plazo" padding={{ top: 20, bottom: 20 }}/>
                                                    <YAxis type="number" dataKey=""/>
                                                    <Tooltip />
                                                    <CartesianGrid strokeDasharray="3 3" />
                                                    <Bar dataKey="tae" fill="#000000" >
                                                        {barColors.map((entry, index) => (
                                                            <Cell key={`cell-${index}`} fill={barColors[index]} />
                                                        ))}
                                                        <LabelList dataKey="tae" position="top" fill="#000" formatter={addPercentLabel}/>
                                                    </Bar>
                                                </BarChart> 
                                            </ResponsiveContainer>
                                            
                                        } 
                                        </div>
                                    :
                                    <div className="d-flex flex-row justify-content-center">
                                        {
                                            rentabilidad?.largoplazo.map((item, idx) => 
                                                <div key={`largoplazo_${idx}`} className="flex-fill" style={{ marginTop: 10 }}>
                                                    <span className="statement">
                                                        {item.tae !== '-' ? parseFloat(item.tae).toFixed(2) + '%' : '-'}
                                                        {(item.tae !== '-' && item.tae > 0) && (<img className="icon" src={arrowTop} alt="flecha arriba"/>)}
                                                        {(item.tae !== '-' && item.tae < 0) && (<img className="icon" src={arrowDown} alt="flecha abajo"/>)}
                                                    </span>
                                                    <span className="statementDetail">
                                                        {plazoToText[item.plazo]}
                                                    </span>
                                                </div>
                                            )
                                        }
                                    </div>
                                    }
                                    
                                </div>
                                <hr className="separator" />
                                <div className="aniosNaturales-display" style={{marginBottom: 20}}>
                                    <h4 className="details-returns-title">Años Naturales</h4>
                                    <div className="switch-display-buttons" id="aniosNat-buttons">
                                        {<ToggleButtonGroup id="aniosNat-toggle" type="radio" name="optionsAniosNat" defaultValue={'aniosNat-1'} className="toggle-options">
                                            <ToggleButton id="aniosNat-radio-1" value={'aniosNat-1'} className="toggle-option-nums" onClick={ () => setAniosNatToggleDisplay(false)}>
                                                <img src={inlineIcon} className="num-icon" alt="icono numero"/>
                                            </ToggleButton>
                                            <ToggleButton id="aniosNat-radio-2" value={'aniosNat-2'} className="toggle-option-graphs" onClick={ () => setAniosNatToggleDisplay(true)}>
                                                <img src={chartIcon} className="chart-icon" alt="icono chart"/>
                                            </ToggleButton> 
                                        </ToggleButtonGroup>}
                                    </div>
                                    {aniosNatToggleDisplay ? 
                                        
                                        <div className="d-flex flex-row justify-content-center">
                                            {    
                                                <ResponsiveContainer  width="100%" height={600}>
                                                    <BarChart width="100%" height="100%" data={aniosNaturalesData} margin={{top: 20, right: 20, bottom: 20, left: 20}} >
                                                        <CartesianGrid strokeDasharray="3 3" />
                                                        <XAxis dataKey="plazo" padding={{ top: 20, bottom: 20 }}/>
                                                        <YAxis type="number" dataKey="" />
                                                        <Tooltip />
                                                        
                                                        <Bar dataKey="acumulado" fill="#000000" >
                                                            {barColors.map((entry, index) => (
                                                                <Cell key={`cell-${index}`} fill={barColors[index]} />
                                                            ))}
                                                            <LabelList dataKey="acumulado" position="top" fill="#000" formatter={addPercentLabel}/>
                                                        </Bar>
                                                    </BarChart> 
                                                </ResponsiveContainer>
                                            } 
                                        </div>
                                    :
                                        <div className="d-flex flex-row justify-content-center">
                                            {
                                                rentabilidad?.aniosnaturales.map((item, idx) => 
                                                <div key={`aniosnaturales_${idx}`} className="flex-fill" style={{ marginTop: 10 }}>
                                                    <span className="statement">
                                                    {item.acumulado !== '-' ? parseFloat(item.acumulado).toFixed(2) + '%' : '-'}
                                                    {(item.acumulado !== '-' && item.acumulado > 0) && (<img className="icon" src={arrowTop} alt="flecha arriba"/>)}
                                                    {(item.acumulado !== '-' && item.acumulado < 0) && (<img className="icon" src={arrowDown} alt="flecha abajo"/>)}                                        
                                                    </span>
                                                    <span className="statementDetail">
                                                        {item.plazo}
                                                    </span>
                                                </div>)
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                                }
                        </div>
                        <div className="legal-text">
                        {rentabilidad?.fechainiciopolitica ? (
                            <p>
                                
                            (*) El día {formatDate(rentabilidad?.fechainiciopolitica)} se produjo un cambio sustancial de política de inversión, por lo que sólo se muestra la evolución del valor liquidativo y rentabilidad desde esa fecha. 
                            </p>
                        ) : null}
                            {
                                (detalleproducto?.tipo === `epvs` ? 
                                    <p>
                                    Para más información puede acceder al <a href={datosFundamentalesURLDIP} target="blank">Documento de Información Previa (DIP)</a>.   
                                    </p>
                                : ""
                                )
                            }
                            {
                                (detalleproducto?.tipo === `fondos` ? 
                                    <p>
                                    Para más información puede acceder al <a href={datosFundamentalesURL} target="blank">Documento de Datos Fundamentales (DDF)</a>.    
                                    </p>
                                : ""
                                )
                            }
                            {
                                ( detalleproducto?.tipo === `planes` ? 
                                    <p>
                                    Para más información puede acceder al <a href={informeProductoURL} target="blank">Documento de Datos Fundamentales para el Partícipe (DDFP)</a>.    
                                    </p>
                                : ""
                                )
                            }
                            {
                                (detalleproducto?.tipo === `sicav` ? 
                                    <p>
                                    Para más información puede acceder al <a href={datosFundamentalesURLKIID} target="blank">Datos Fundamentales para el Inversor (KIID)</a>.    
                                    </p>
                                : ""
                                )
                            }
                            <p>Rentabilidades superiores a un año son TAE.</p>
                            <p><strong>Rentabilidades pasadas no presuponen en ningún caso rentabilidades futuras. Cualquier referencia a resultados pasados no deberá interpretarse como una indicación de resultados futuros. Toda inversión en mercados financieros está sujeta a riesgos, incluido el riesgo de pérdida del principal invertido.</strong> Entre ellos cabe mencionar, a título enunciativo y no limitativo, riesgos de mercado, de crédito, de emisor y contrapartida, de liquidez, de cambio de moneda por fluctuaciones de valor y a la posible pérdida del capital invertido. Asimismo, cualquier decisión de suscripción sobre participaciones de las instituciones de inversión colectiva a las que se alude en este apartado, debería adoptarse teniendo en cuenta el documento que recoge los 
                            {
                                (detalleproducto?.tipo === `epvs` ? 
                                    <a href={datosFundamentalesURLDIP} target="blank"> Documento de Información Previa (DIP)</a> 
                                : ""
                                )
                            }
                            {
                                (detalleproducto?.tipo === `fondos` ? 
                                    <a href={datosFundamentalesURL} target="blank"> Documento de Datos Fundamentales (DDF)</a>
                                : ""
                                )
                            }
                            {
                                (detalleproducto?.tipo === `planes` ? 
                                    <a href={informeProductoURL} target="blank"> Documento de Datos Fundamentales para el Partícipe (DDFP).</a>
                                : ""
                                )
                            }
                            {
                                (detalleproducto?.tipo === `sicav` ? 
                                    <a href={datosFundamentalesURLKIID} target="blank"> Datos Fundamentales para el Inversor (KIID)</a> 
                                : ""
                                )
                            }
                            . Este documento debe ser consultado por el inversor con carácter previo a cualquier decisión de inversión, suscripción o desinversión y le ayudará a comprender la naturaleza y los riesgos que conlleva invertir en la IIC.</p>
                        </div>
                        <div className="row-detail">
                            <h4 className="blueText" id="gestor">Gestor</h4>
                            {
                                datosgestores?.slice(0,2).map((item, idx) =>
                                    <div key={`gestor_${idx}`} className="box-detail">
                                        <div className="row">
                                            <div className="col-lg-4 col-sm-12" style={{textAlign: 'center'}}>
                                                <img className="img-gestor" alt="imagen del gestor" src={item.urlCv} />
                                            </div>
                                            <div className="col-lg-8 col-sm-12" style={{}}>
                                                <h5 className="title-manager">{item.nombre}</h5>
                                                <p className="text-manager">{item.textoCv}</p>
                                            </div>
                                        </div>
                                    </div>                        
                                )
                            }
                        </div>
                        <MoveTopButton />
                    </div>

                    <Modal
                        className="modalShadowBox searcher-funds-react23"
                        title={<div style={{display: 'flex', justifyContent: 'center', marginTop: 15}}>
                            <span className="blueText" style={{fontWeight: 600, fontSize: 20, margin: 'auto'}}>{showDetailModal.title}</span>
                        </div>}
                        open={modalVisible}
                        onCancel={() => {setModalVisible(false)}}
                        footer={null}
                        closeIcon={<i className="fa-solid fa-x" style={{color: 'red'}}></i>}

                        >
                            {showDetailModal.content}
                    </Modal>
                </div>
            )}
        </>
    );
};

export default RentabilidadesTab;